/* eslint-disable import-x/no-anonymous-default-export */

export default {
  CREATE: 'CREATE',
  SHOW: 'SHOW',
  INDEX: 'INDEX',
  UPDATE: 'UPDATE',
  DESTROY: 'DESTROY',
  BATCHDESTROY: 'BATCHDESTROY'
}
